import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const getDropSimilarityScoreByRatioEndpoint = {
    [dropEndpointIds.GET_DROP_SIMILARITY_SCORE_BY_RATIO]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
                ratio: { type: 'number' },
            },
            required: ['dropId'],
        },
    },
};
